import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'

export default {
    taskName: taskName.PRODUCE_ALIGNER_EXTERNAL,
    taskOverviewProps: {},
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.TREATMENT_DURATION_WIDGET_CONTAINER,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_PLAN_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.SCAN_FILE_UPLOAD_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_PLAN_FILE_UPLOAD_WIDGET,
        },
        {
            component: processUI.PRODUCTION_FILE_UPLOAD_WIDGET,
        },
    ],
    actionList: [
        {
            action: processAction.TREATMENT_PLAN,
            taskPath: ['objectDetail', 'customer', 'treatmentPlanList', 0],
        },
        {
            action: processAction.SALES_ORDER,
            taskPath: ['objectDetail'],
        },
        {
            action: processAction.CUSTOMER,
            taskPath: ['objectDetail', 'customer'],
        },
    ],
}



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/treatment/produce-aligner-external.js